import { createI18n } from 'vue-i18n';
import da from '../locales/da.json';
import de from '../locales/de.json';
import en_US from '../locales/en_US.json';
import es from '../locales/es.json';
import fi from '../locales/fi.json';
import fr_CA from '../locales/fr_CA.json';
import fr_FR from '../locales/fr_FR.json';
import it from '../locales/it.json';
import nl from '../locales/nl.json';
import no from '../locales/no.json';
import pt_BR from '../locales/pt_BR.json';
import pt_PT from '../locales/pt_PT.json';
import sv from '../locales/sv.json';
export function setupVueI18n(locale) {
    const i18n = createI18n({
        locale,
        globalInjection: true,
        legacy: false,
        runtimeOnly: true,
        fallbackLocale: 'en_US',
        messages: {
            en_US,
            da,
            de,
            es,
            fi,
            fr_CA,
            fr_FR,
            it,
            nl,
            no,
            pt_BR,
            pt_PT,
            sv,
        },
    });
    // replace app name here variable name mountAppContext({ microApp }) should match
    if (window === null || window === void 0 ? void 0 : window.domainConnectApp)
        window.domainConnectApp.use(i18n);
}
